import { useSelector } from 'react-redux'
import { getCategoryList } from 'lib/core/data/common/categoryList/selectors'

export const useCategoryList = () => {
  const categories = useSelector(getCategoryList)
  return categories
}
